import React, { useState } from 'react';
import Sidebar, { MobileHeader } from './Sidebar';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-br from-secondary-50 via-white to-primary-50/30">
      {/* Mobile Header */}
      <MobileHeader onMenuClick={() => setSidebarOpen(true)} />

      <div className="flex">
        {/* Sidebar */}
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        {/* Main Content */}
        <main className="flex-1 min-h-screen lg:ml-64">
          <div className="pt-16 lg:pt-0 w-full h-full">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;